import { useState, useEffect } from "react";
import { Radio } from "antd";
import { ReactComponent as InstagramIcon } from "assets/images/instagram-icon.svg";
import { ReactComponent as TikTokIcon } from "assets/images/tiktok-icon.svg";
import "./PlatformFilter.scss";
import { BaseFilterProps } from "interfaces/filter-component-base";

const PlatformFilter = (props: BaseFilterProps) => {
  const { onChangeValues, values } = props;
  const [selectedPlatform, setSelectedPlatform] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    if (values && typeof values === "string") {
      setSelectedPlatform(values);
    } else if (values && Array.isArray(values) && values.length > 0) {
      setSelectedPlatform(values[0]);
    } else {
      setSelectedPlatform(undefined);
    }
  }, [values]);

  const handlePlatformChange = (e: any) => {
    const platform = e.target.value;
    setSelectedPlatform(platform);
    if (onChangeValues) {
      onChangeValues(platform);
    }
  };

  return (
    <div className="platform-radio-items">
      <Radio.Group
        value={selectedPlatform}
        onChange={handlePlatformChange}
        className="platform-radio-group"
      >
        <label className="platform-radio-item">
          <div className="platform-radio-icon instagram">
            <InstagramIcon />
          </div>
          <div className="platform-radio-content">
            <p className="platform-radio-content-title">Instagram</p>
          </div>
          <div className="platform-radio">
            <Radio value="instagram" />
          </div>
        </label>
        <label className="platform-radio-item">
          <div className="platform-radio-icon tiktok">
            <TikTokIcon />
          </div>
          <div className="platform-radio-content">
            <p className="platform-radio-content-title">TikTok</p>
          </div>
          <div className="platform-radio">
            <Radio value="tiktok" />
          </div>
        </label>
      </Radio.Group>
    </div>
  );
};

export default PlatformFilter;
